export default __webpack_public_path__ + "assets/hotgig-logo.bd44bf94.png";